import { orderBy } from 'lodash';
import ChatGroup from './ChatGroup';
import ChatUser from './ChatUser';

export default class ChatTargetContainer {
  static readonly EMPTY = new ChatTargetContainer();

  users: Array<ChatUser> = [];
  groups: Array<ChatGroup> = [];

  order(): void {
    this.groups = orderBy(this.groups, 'name', 'asc');
    this.users = orderBy(this.users, 'fullName', 'asc');
  }
}